import React, { createContext, useContext } from 'react';
import { ListWithPagination } from '@anytag/shared-molecules';
import { SocialAccountInfluencerListSortField } from '@anytag/graphql';
import { useInfluencerParamsSearch } from '../hooks';
import { InfluencersContextReturnType } from '../schemaTypes';
import { useThreadsInfluencersList } from './hooks';
import {
  ThreadsInfluencersProps,
  ThreadsInfluencerProfile,
  ThreadsInfluencersFilterFormValues,
  ThreadsInfluencersSearchSchemaType
} from './schemaTypes';

type ContextType = InfluencersContextReturnType<
  ThreadsInfluencerProfile,
  ThreadsInfluencersFilterFormValues,
  SocialAccountInfluencerListSortField
>;

const Context = createContext<ContextType>({} as ContextType);

interface Props {
  value: ThreadsInfluencersProps;
  children: React.ReactElement | Array<React.ReactElement>;
}

export const ThreadsInfluencersProvider = ({
  children,
  value: {
    isTtcmCampaign,
    isPackagePage,
    isEngagementPage,
    getCurrentProfiles,
    getSortSelectButtonProps,
    getListSelectButtonProps
  }
}: Props) => {
  const paramsSearch = useInfluencerParamsSearch<ThreadsInfluencersSearchSchemaType>();
  const { page, sort, limit, filter } = paramsSearch;
  const listProps = useThreadsInfluencersList({ page, sort, limit, filter, getCurrentProfiles });

  return (
    <Context.Provider
      value={{
        ...paramsSearch,
        ...listProps,
        isTtcmCampaign,
        isPackagePage,
        isEngagementPage,
        getListSelectButtonProps,
        sortSelectButtonProps: getSortSelectButtonProps?.(listProps.listRecords, listProps.totalRecords)
      }}
    >
      <ListWithPagination pagination={{ totalRecords: listProps.totalRecords }}>{children}</ListWithPagination>
    </Context.Provider>
  );
};

export const useThreadsInfluencersContext = () => useContext<ContextType>(Context);
